document.addEventListener("DOMContentLoaded", () => {

  /* ================================
     VARIANT CHANGE
  ================================= */
  document.addEventListener("change", function (e) {
    if (!e.target.classList.contains("card-variant-select")) return;

    const card = e.target.closest(".product-card");
    if (!card) return;

    const input = card.querySelector(".selected-variant-id");
    if (input) input.value = e.target.value;
  });

  /* ================================
     OPEN CART DRAWER
  ================================= */
  function openCartDrawer() {
    const drawer = document.getElementById("cart-drawer");
    if (!drawer) return;

    drawer.setAttribute("open", "");
    drawer.setAttribute("aria-hidden", "false");
    drawer.classList.add("is-active");
    document.body.classList.add("overflow-hidden");
  }

  /* ================================
     CLOSE CART DRAWER
  ================================= */
  function closeCartDrawer() {
    const drawer = document.getElementById("cart-drawer");
    if (!drawer) return;

    drawer.removeAttribute("open");
    drawer.setAttribute("aria-hidden", "true");
    drawer.classList.remove("is-active");
    document.body.classList.remove("overflow-hidden");
  }

  /* ================================
     OUTSIDE CLICK CLOSE
  ================================= */
  document.addEventListener("click", function (e) {
    const drawer = document.getElementById("cart-drawer");
    if (!drawer || !drawer.classList.contains("is-active")) return;

    // Close button
    if (e.target.closest(".drawer__close-btn")) {
      closeCartDrawer();
      return;
    }

    // Click outside drawer content
    if (
      e.target.closest("cart-drawer") &&
      !e.target.closest(".drawer__content")
    ) {
      closeCartDrawer();
    }
  });

  /* ================================
     ESC KEY CLOSE
  ================================= */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeCartDrawer();
    }
  });

  /* ================================
     REFRESH CART DRAWER CONTENT
  ================================= */
  function refreshCartDrawer() {
    fetch("/?section_id=cart-drawer")
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newDrawer = doc.getElementById("cart-drawer");
        const currentDrawer = document.getElementById("cart-drawer");

        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
        }
      });
  }

  /* ================================
     AJAX ADD TO CART
  ================================= */
  document.addEventListener("submit", function (e) {
    if (!e.target.classList.contains("card-add-to-cart-form")) return;

    e.preventDefault();

    const form = e.target;
    const variantInput = form.querySelector(".selected-variant-id");
    const button = form.querySelector("button");
    const message = form.querySelector(".cart-message");

    if (!variantInput || !variantInput.value) return;

    button.disabled = true;
    button.textContent = "Adding...";

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: variantInput.value,
        quantity: 1
      })
    })
    .then(res => {
      if (!res.ok) throw new Error("Add to cart failed");
      return res.json();
    })
    .then(() => {
      refreshCartDrawer();
      openCartDrawer();

      if (message) {
        message.style.display = "block";
        message.textContent = "Product added to cart";
      }

      button.textContent = "Added ✓";

      setTimeout(() => {
        button.textContent = "Add to Cart";
        button.disabled = false;
      }, 1500);
    })
    .catch(err => {
      console.error(err);
      button.textContent = "Error";

      setTimeout(() => {
        button.textContent = "Add to Cart";
        button.disabled = false;
      }, 1500);
    });
  });

});